const config = {
  siteName: "DeathroW Esport | Site officiel de l’équipe et son académie",
  siteDescription: "DeathroW Esport, club esportif français révélateur de talents. Présent depuis 2001 dans le paysage des compétitions électroniques, formateur et innovant.",
  siteUrl: "https://deathrowesport.com",
  twitterName: "DeathrowEU",
  email: "deathrowec@gmail.com",
};

export default config;
